import { Injectable, signal } from '@angular/core';

/** Etapas do assistente do gráfico. */
export type ChartWizardStep = 'type' | 'data' | 'look';

export type ChartWizardState =
    /** Gráfico novo: entra onde o menu "Inserir campo" foi aberto. */
    | { mode: 'create'; step: 'type'; aboveFieldId?: string; belowFieldId?: string }
    /** Gráfico que já existe: reabre na etapa pedida pelo card. */
    | { mode: 'edit'; step: ChartWizardStep; fieldId: string };

/**
 * Abre e fecha o assistente do gráfico. O menu "Inserir campo" abre para criar; o card do
 * gráfico abre para editar os dados ou a aparência. Quem desenha o modal é a lista de
 * itens da seção (como os outros modais do editor).
 */
@Injectable({ providedIn: 'root' })
export class ChartWizardService {
    private _state = signal<ChartWizardState | null>(null);
    public readonly state = this._state.asReadonly();

    public openCreate(aboveFieldId?: string, belowFieldId?: string): void {
        this._state.set({ mode: 'create', step: 'type', aboveFieldId, belowFieldId });
    }

    public openEdit(fieldId: string, step: ChartWizardStep): void {
        this._state.set({ mode: 'edit', step, fieldId });
    }

    public close(): void {
        this._state.set(null);
    }
}
